import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const SkeletonCustomerMasterGrid = ({ rows = 5 }) => {
  return (
    <section id="companyMasterList">
        <div className='container-fluid'>
            <div className='row company-table-row mb-4rem'>
            <div className='col-12'>
                <div className='card mt-0 company-list-card'>
                <div className="card-body mb-2">
                    <div className="table-responsive company-table-responsive">
                    <table className="table table-borderless table-list company-table-list">
                        <thead>
                        <tr>
                            <th><div>COMPANY</div></th>
                            <th><div>WEBSITE</div></th>
                            <th><div>COUNTRY</div></th>
                            <th><div>AUTHORIZED PERSON</div></th>
                            <th><div>EMAIL</div></th>
                            <th><div>PHONE NUMBER</div></th>
                            <th><div>STATUS</div></th>
                            <th><div>ACTIONS</div></th>
                        </tr>
                        </thead>

                        <tbody>
                        {Array.from({ length: rows }).map((_, index) => (
                            <tr key={index}>
                            <td className='clickable-cell'>
                                <div className='company-cell'>
                                <div className='mr-2'>
                                    <Skeleton width={32} height={15} />
                                </div>
                                <h5>
                                    <Skeleton width={233} height={15} />
                                </h5>
                                </div>
                            </td>
                            <td><Skeleton width={104} height={15} /></td>
                            <td><Skeleton width={122} height={15} /></td>
                            <td><Skeleton width={120} height={15} /></td>
                            <td><Skeleton width={50} height={15} /></td>
                            <td><Skeleton width={50} height={15} /></td>
                            <td><Skeleton width={60} height={15} /></td>
                            <td><Skeleton width={64} height={15} /></td>
                            </tr>
                        ))}
                        </tbody>

                    </table>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>
  );
};

export default SkeletonCustomerMasterGrid